exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper-pagination{width:100%;height:20px;left:0;margin-top:-20px;line-height:16px}.swiper-pagination .circle{display:inline-block;width:7px;height:7px;border-radius:50%;margin-right:4px}.swiper-pagination .circle:last-of-type{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/swiper/SwiperPagination.vue
// module id = 174
// module chunks = 0